import React, { useMemo } from 'react';
import { Icon } from '@ss/mtd-react3';
import { navigatePage } from '@cap/share/src/utils/navigation';
import { lx } from '@cap/rzmt-core';
import { useAppSelector } from '@/store/hooks';
import { selectCurModuleContentData, homeDataLoadStatus, selectCurIcon } from '@/pages/home/homeCourseData';
import { LoadStatus } from '@/components/LoadPlaceholder';
import Course from '@/components/Course';
import { EnumModuleCode } from '@/utils/const';
import './index.less';

const CourseList: React.FC = () => {
  const pularLiveData = useAppSelector(selectCurModuleContentData);

  const loadStatus = useAppSelector(homeDataLoadStatus);

  const dataRule = useAppSelector(selectCurIcon).dataRule as unknown as string;
  const viewAll = (item) => {
    lx.moduleClick({
      bid: 'b_donation_ld546r2f_mc',
    });

    navigatePage('/web/view-all', {
      query: { type: item.moduleDisplayTitle, moduleId: item.moduleId, dataRule },
      windowOpen: true,
    });
  };

  // 获取并存储 moduleCode 为 Live 的数据
  const dataList = useMemo(() => {
    const targetData = pularLiveData.filter((c) => c.moduleCode === EnumModuleCode.Course && c.courseList.length > 0);

    return (
      targetData || {
        page: { pageNo: 1, pageSize: 10, totalCount: 0, totalPageCount: 0 },
        courseList: [],
        moduleId: 0,
        moduleCode: EnumModuleCode.Course,
        moduleDisplayTitle: '',
      }
    );
  }, [pularLiveData]);

  return (
    <div>
      {loadStatus !== LoadStatus.SUCCESS ? (
        <div className="home-course-margin-auto">
          <img
            className="loading-icon"
            src="//s3plus-img.meituan.net/v1/mss_a15b7cd66e264e09b68e65865d5f8e2b/mtdx/mtdx-loading.gif"
            alt="loading"
          />
        </div>
      ) : (
        dataList.map((item) => {
          return (
            <div className="home-course-list">
              <div className="top-title">
                <div className="title">{item.moduleDisplayTitle}</div>
                <div className="icon" onClick={() => viewAll(item)}>
                  查看全部
                  <Icon type="right" className="right" />
                </div>
              </div>

              <div className="course-card">
                {item.courseList.slice(0, 4).map((c) => {
                  return <Course courseData={c} key={c.id} />;
                })}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default CourseList;
